// extracted by mini-css-extract-plugin
export var formContainer = "_hs-0";
export var message = "_hs-1";